import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        formSubmission: '=',
        loadTest: '&',
        stopTimer: '&',
        form: '=',
        timeLeft: '=',
        showButton: '=',
        showGenericError: '=',
        showSuccessMessage: '=',
        errors: '=',
        isQuizOverview: '=',
        isPageBeforeOverview: '='
    },
    template: `
        <div class="{{ vm.getFooterCssClass() }}">
            <p class="{{ vm.getProgressCssClass() }}">
                <span ng-if="!vm.isQuizOverview" ng-bind-html="vm.getQuestionCounter()"></span>
                <span ng-if="vm.formSubmission.form.timeToAnswer > 0 && vm.timeLeft" class="ico-clock">
                    {{ 'forms.Time left:' | translate }}
                    <strong>{{ vm.timeLeft.utc().format('HH:mm:ss') }}</strong>
                </span>
            </p>
            <button ng-if="vm.showButton" class="{{ vm.getButtonCssClass() }}" ng-click="vm.submit()">{{ vm.getSubmitButtonText() }}</button>
        </div>
    `
})
export default class {
    constructor ($window, $scope, $state, $translate, $interval, lodash, toastr, moment, ResponseService, FormSubmissionAnswerResource, ErrorHandlerFactory,
                 FORMS_SUBMISSION_STATUS_ENUM, FORMS_DISPLAY_TYPE_ENUM) {
        this.$window = $window;
        this.$scope = $scope;
        this.$state = $state;
        this.$translate = $translate;
        this.$interval = $interval;
        this.lodash = lodash;
        this.toastr = toastr;
        this.moment = moment;
        this.FormSubmissionAnswerResource = FormSubmissionAnswerResource;
        this.ResponseService = ResponseService;
        this.ErrorHandlerFactory = ErrorHandlerFactory;
        this.FORMS_SUBMISSION_STATUS_ENUM = FORMS_SUBMISSION_STATUS_ENUM;
        this.FORMS_DISPLAY_TYPE_ENUM = FORMS_DISPLAY_TYPE_ENUM;

        $scope.$on('quiz:submit', () => {
            this.submit(true);
        });
    }

    getProgressCssClass () {
        return this.formSubmission.isTrial ? 'progress center' : 'progress';
    }

    getButtonCssClass () {
        return this.formSubmission.isTrial ? 'btn next main f-right' : 'btn next main';
    }

    getFooterCssClass () {
        return this.isOverViewOrOnePage() ? 'quiz-footer fixed' : 'quiz-footer';
    }

    showCounter () {
        return this.formSubmission.form.displayType === this.FORMS_DISPLAY_TYPE_ENUM.KEYS.SEPARATE_PAGES
        && this.formSubmission.form.questionsPerPage === 1 && !this.isQuizOverview;
    }


    getQuestionCounter () {
        if (!this.showCounter()) {
            // return empty string as this method result is rendered inside span element
            return '';
        }
        let active = parseInt(this.formSubmission.finishedQuestionCount, 10) + 1;

        // Fix for the last question submission not to show more than question count
        if (parseInt(this.formSubmission.finishedQuestionCount, 10) === parseInt(this.formSubmission.totalQuestionCount, 10)) {
            active = this.formSubmission.finishedQuestionCount;
        }

        return this.$translate.instant('forms.<strong>{active}</strong> of <strong>{total}</strong> questions', {
            active,
            total: this.formSubmission.totalQuestionCount
        });
    }

    isResend () {
        if (this.resend) {
            return true;
        }
        return this.formSubmission.form.displayType === this.FORMS_DISPLAY_TYPE_ENUM.KEYS.SEPARATE_PAGES
            && this.formSubmission.finishedQuestionCount === this.formSubmission.totalQuestionCount;
    }

    submit () {
        if (this.formSubmission.isTrial && this.isPageBeforeOverviewOrOnePage()) {
            this.stopTimer();
            this.$state.go('authorized.forms.forms.form.general', { id: this.formSubmission.formId });
            return;
        }
        this.errors = [];
        this.showButton = false;
        this.showGenericError = false;
        this.showSuccessMessage = false;
        const params = { expand: 'form,occurrenceTraining', resend: this.isResend() };

        if (this.$state.params.fallbackLanguage) {
            params.fallbackLanguage = this.$state.params.fallbackLanguage;
        }
        this.FormSubmissionAnswerResource
            .batchCreate(params, this.form)
            .$promise.then((data) => {
                this.formSubmission = data;
                if (this.resend) {
                    this.showSuccessMessage = true;
                    this.resend = false;
                }
                if (data.status === this.FORMS_SUBMISSION_STATUS_ENUM.KEYS.FINISHED) {
                    this.stopTimer();
                    this.$state.go('quiz.finished', { guid: this.formSubmission.guid });
                }
                else if (data.status === this.FORMS_SUBMISSION_STATUS_ENUM.KEYS.IN_PROGRESS) {
                    this.loadTest({ formSubmission: this.formSubmission }, false);
                }
            }).catch(response => {
                this.handleResponse(response);
            });
    }

    handleResponse (response) {
        this.$window.scrollTo(0, 0);
        this.showButton = true;
        // check if server gave form error
        if (response.status === 422) {
            const errors = this.ErrorHandlerFactory.parseFormErrors(response);
            this.lodash.forEach(errors, (error) => {
                if (this.errors.indexOf(error) === -1) {
                    this.errors.push(error);
                }
            });
        }
        else {
            this.resend = true;
            const message = this.lodash.get(response, 'data.message', false);
            if (message) {
                this.errors.push(message);
            }
            else {
                this.showGenericError = true;
            }
        }
    }

    isOnePage () {
        const isDisplayTypeOnePage = this.formSubmission.form.displayType === this.FORMS_DISPLAY_TYPE_ENUM.KEYS.ONE_PAGE;
        const isOnePageInSplitMode = this.formSubmission.form.questionCount <= this.formSubmission.form.questionsPerPage;

        // is display type all on one page
        if (isDisplayTypeOnePage) {
            return true;
        }

        // is split mode and question count less or equal question per page
        return isOnePageInSplitMode;
    }

    isOverViewOrOnePage () {
        return this.isQuizOverview || this.isOnePage();
    }

    isPageBeforeOverviewOrOnePage () {
        return this.isPageBeforeOverview || this.isOnePage();
    }

    getSubmitButtonText () {
        if (this.formSubmission.isTrial && this.isPageBeforeOverviewOrOnePage()) {
            return this.$translate.instant('forms.Back to form');
        }
        if (this.isOverViewOrOnePage()) {
            return this.$translate.instant('general.Save');
        }
        return this.$translate.instant('general.Next');
    }
}



// WEBPACK FOOTER //
// ./src/app/components/quiz/footer/index.js